module.exports = __webpack_public_path__ + "static/rg-bg-0-40bafa85b9aadaefbbfadf7151cb3cf8.jpeg";